<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="220px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="appKey" prop="appKey">
            <el-input v-model.trim="form.appKey" />
          </el-form-item>
          <el-form-item label="appSecret" prop="appSecret">
            <el-input v-model.trim="form.appId" show-password />
          </el-form-item>
          <el-form-item label="店铺ID" prop="shopId">
            <el-input v-model.trim="form.shopId" />
          </el-form-item>
          <el-form-item label="商品列表">
            <el-button
              type="primary"
              @click="addProduct"
            >
              添加
            </el-button>
            <el-row gutter="20" v-if="form.productList.length">
              <el-col :span="6">商品ID</el-col>
              <el-col :span="6">商品名称</el-col>
              <el-col :span="6">短信模板编号</el-col>
              <el-col :span="6">操作</el-col>
            </el-row>
            <el-row
              gutter="20"
              v-for="(item, index) of form.productList"
              :key="index"
            >
              <el-col :span="6">
                <el-input v-model="item.productId" placeholder="商品ID" />
              </el-col>
              <el-col :span="6">
                <el-input v-model="item.productName" placeholder="商品名称" />
              </el-col>
              <el-col :span="6">
                <el-input v-model="item.project" placeholder="短信模板编号" />
              </el-col>
              <el-col :span="6">
                <el-button
                  type="warning"
                  @click="delProduct(index)"
                >
                  删除
                </el-button>
              </el-col>
            </el-row>
            
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDouDian, setDouDian } from '@/api/super'
export default {
  name: 'SettingsSaiYou',
  data() {
    return {
      labelPosition: 'right',
      form: {
        appSecret: '',
        appKey: '',
        shopId: '',
        productList: []
      },
      rules: {
        // accessKey: [
        //   { required: true, message: '请输入accessKey', trigger: 'blur' },
        // ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    addProduct() {
      this.form.productList.push({
        productId: '',
        productName: '',
        project: '',
      })
    },
    delProduct(index) {
      this.form.productList.splice(index, 1)
    },
    async getData() {
      const ret = await getDouDian()
      this.form.appSecret = ret && ret.basic && ret.basic.appSecret
      this.form.appKey = ret && ret.basic && ret.basic.appKey
      this.form.shopId = ret && ret.basic && ret.basic.shopId
      this.form.productList = ret && ret.basic && ret.basic.productList || []
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({},this.form)
          await setDouDian({
            config: form,
          })
          this.getData()
          this.$message.success('保存抖店配置成功')
        } else {
          this.$message.success('保存抖店配置失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
.title {
  color: #c3c3c3;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;
}
</style>
